import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=1a8960ec&scoped=true&"
import script from "./SelectField.vue?vue&type=script&lang=js&"
export * from "./SelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8960ec",
  null
  
)

export default component.exports